export default __webpack_public_path__ + "chating-kids-blue.png?64eef20ac1bcc32895503e1729fffd10";